import { render, staticRenderFns } from "./ym-profit.vue?vue&type=template&id=5703373e&scoped=true&"
import script from "./ym-profit.vue?vue&type=script&lang=js&"
export * from "./ym-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703373e",
  null
  
)

export default component.exports